import { useState } from 'react';

export default function HeroSection() {
  const [searchFocused, setSearchFocused] = useState(false);

  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dimly%20lit%20theater%20backstage%20with%20dramatic%20spotlights%20cutting%20through%20darkness%2C%20red%20velvet%20curtains%20partially%20drawn%2C%20hazy%20atmosphere%20with%20floating%20dust%20particles%20in%20light%20beams%2C%20cinematic%20deep%20shadows%20and%20warm%20amber%20highlights%2C%20editorial%20fashion%20photography%20aesthetic%20with%20mysterious%20mood&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
        alt="黑料入口 - 最新娱乐资讯"
        title="黑料入口 51吃瓜黑料入口一二三 黑料入口官网"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-[800px] mx-auto text-center">
        <h1 className="font-heading text-5xl md:text-7xl font-bold text-white leading-tight mb-6">
          黑料入口
        </h1>
        <p className="text-lg md:text-xl text-white/70 mb-4 leading-relaxed">
          51吃瓜黑料入口一二三 | 黑料入口官网 · 黑料入口下载
        </p>
        <p className="text-sm md:text-base text-white/60 mb-10 max-w-xl mx-auto leading-relaxed">
          每日更新黑料网在线观看、吃瓜黑料在线等热门内容，为你整理安全可用的最新访问方式
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <div className={`relative w-full sm:w-96 transition-all duration-300 ${searchFocused ? 'scale-105' : ''}`}>
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-white/50 text-lg"></i>
            <input
              type="text"
              placeholder="搜索你关心的吃瓜内容..."
              className="w-full pl-11 pr-4 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white placeholder-white/40 text-sm border border-white/20 focus:outline-none focus:border-white/40 transition-all"
              onFocus={() => setSearchFocused(true)}
              onBlur={() => setSearchFocused(false)}
            />
          </div>
          <button className="whitespace-nowrap px-8 py-3.5 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer">
            立即吃瓜
          </button>
        </div>

        <div className="flex items-center justify-center gap-6 mt-8">
          <span className="text-white/40 text-xs">热搜追踪</span>
          <span className="text-white/40 text-xs">·</span>
          <span className="text-white/40 text-xs">明星八卦</span>
          <span className="text-white/40 text-xs">·</span>
          <span className="text-white/40 text-xs">影视吃瓜</span>
          <span className="text-white/40 text-xs">·</span>
          <span className="text-white/40 text-xs">网红爆料</span>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/40 text-2xl"></i>
      </div>
    </section>
  );
}